import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-gears',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingGearsComponent {}
